import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const CardBody = ({ children, className, tag: Tag }) => (
  <Tag className={classnames('card-body', className)}>{children}</Tag>
);

CardBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.node,
};

CardBody.defaultProps = {
  children: null,
  className: null,
  tag: 'div',
};

export default CardBody;
